module.exports = __webpack_public_path__ + "static/img/profile_m.afff988.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/profile_m.jpg
// module id = 5Oc9
// module chunks = 0